<template>
    <div class="mainbody modulewrap">
        <div class="banner">
            <div class="bannerimg"><img :src="banner" /></div>
            <div class="sloganwrap"><div class="sloganbox realwrap"><div class="slogan"><span v-html="slogan"></span></div></div></div>
        </div>
        <div class="infowrap" v-for="item in infolist" :key="item.id">
            <div class="infotype1" v-if="item.infotypekv==1">
                <div class="infobox realwrap">
                    <div class="title"><div class="word"><span>{{$common.langinfo(item.title,item.title_en)}}</span></div><div class="line"><span></span></div></div>
                    <div class="content editor"><span v-html="$common.langinfo(item.content,item.content_en)"></span></div>
                </div>
            </div>
            <div class="infotype2" v-else-if="item.infotypekv==2">
                <div class="infobox realwrap" @mousemove="item.x_options.isstop=true" @click="item.x_options.isstop=true" @mouseout="item.x_options.isstop=false">
                    <div class="title"><div class="word">{{$common.langinfo(item.title,item.title_en)}}</div><div class="line"><span></span></div></div>
                    <div class="swiper"><ffswiper :infolist="item.x_children" :options="item.x_options" :indexcur.sync="item.x_indexcur" :direct.sync="item.x_direct"></ffswiper></div>
                    <div class="swiperbtn"><a href="#" @click="item.x_indexcur--;item.x_direct=2"><i class="iconfont icon-fanye"></i></a><a href="#" @click="item.x_indexcur++;item.x_direct=1"><i class="iconfont icon-fanye1"></i></a></div>
                </div>
            </div>
            <div class="infotype3" v-else-if="item.infotypekv==3">
                <div class="infobox realwrap" @mousemove="item.x_options.isstop=true" @click="item.x_options.isstop=true" @mouseout="item.x_options.isstop=false">
                    <div class="title"><div class="word">{{$common.langinfo(item.title,item.title_en)}}</div><div class="line"><span></span></div></div>
                    <div class="swipercon">
                        <div class="swiperleft"><a href="#" @click="item.x_indexcur--;item.x_direct=2"><i class="iconfont icon-fanye"></i></a></div>
                        <div class="swiper"><ffswiper :infolist="item.x_children" :options="item.x_options" :indexcur.sync="item.x_indexcur" :direct.sync="item.x_direct"></ffswiper></div>
                        <div class="swiperright"><a href="#" @click="item.x_indexcur++;item.x_direct=1"><i class="iconfont icon-fanye1"></i></a></div>
                    </div>

                </div>
            </div>
            <div class="infotype4" v-else-if="item.infotypekv==4">
                <div class="infobox realwrap">
                    <div class="title"><div class="word">{{$common.langinfo(item.title,item.title_en)}}</div><div class="line"><span></span></div></div>
                    <ul class="infocollege">
                        <li v-for="item in collegelist" :key="item.id">
                            <dl>
                                <dt><router-link :to="item.url"><img :src="item.cover" /></router-link></dt>
                                <dd>
                                    <span class="a"> <router-link :to="item.url"><img :src="item.logo" /></router-link></span>
                                    <span class="b"> <router-link :to="item.url">{{$common.langinfo(item.title,item.title_en)}}</router-link></span>
                                    <span class="c"> <router-link :to="item.url">{{$common.dicword('gonow')}}</router-link></span>
                                </dd>
                            </dl>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="infotype6" v-if="item.infotypekv==6">
                <div class="infobox realwrap">
                    <div class="title"><div class="word"><span>{{$common.langinfo(item.title,item.title_en)}}</span></div><div class="line"><span></span></div></div>
                    <div class="subtitle" v-if="item.note">{{$common.langtitle(item.note)}}</div>
                    <div class="content editor2"><span v-html="$common.langinfo(item.content,item.content_en)"></span></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'home',
        data() {
            return {
                banner: '',
                slogan: '',
                infolist: [],
                collegelist: []
            };
        },
        mounted() {

            this.$common.fetch({ 'act': 'tc_home' }, res => {
                this.banner = res.infodata.banner;
                this.slogan = this.$common.langinfo(res.infodata.content, res.infodata.content_en);
                this.$common.each(res.infodatainfo, (item) => {
                    if (item.infotypekv == 2) {
                        item.x_children = [];
                        if (item.imgs) {
                            let imgs = item.imgs.split(',');
                            imgs.forEach((itemimg, indeximg) => {
                                item.x_children.push({ 'id': indeximg, 'img': itemimg });
                            });
                        }
                    }
                    else {
                        item.x_children = res.infodatainfosub.filter(item2 => item2.infoid == item.id);
                    }
                    item.x_haschild = (this.$common.basic.chempty(item.x_children));
                    item.x_indexcur = 0;
                    item.x_options = { 'type': item.infotypekv == 2 ? 'image' : 'content', 'isautoplay': true, 'isstop': false };
                    item.x_direct = 1;
                });
                this.infolist = res.infodatainfo;
                this.$common.each(res.infodatacollege, (item) => {
                    item.url = "/college/" + item.alias;
                });
                this.collegelist = res.infodatacollege;
            });
        }

    }
</script>
